import React from 'react';
import src from '../../../assets/images/camera-offline.png';
import './sytle.css'

const NoVideoComponent = () => {
    return (
        <div className='no-video'>
            <img src={src}
                 draggable={false}
            />
        </div>
    )
};


export default NoVideoComponent